import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {
  public isAuthentificated: boolean;
  public userEmail = '';

  public constructor() {
    this.isAuthentificated = false;
  }

  setUserEmail(email) {
    this.userEmail = email;
  }
  getUserEmail() {
    return this.userEmail;
  }
}
